import React from 'react';
import { MDBRow, MDBCol } from "mdbreact";
import Carusel from "../../../components/CardCarusel/CardCarusel.jsx";
import TransModal from '../../../components/TransitionModal/TransitionModal.jsx';

const topChars = (_string) => {
    let mystring = _string.substring(0, 100);
    return mystring;
}

const RightArticle = (props) => {
    return (
        <MDBRow>
            <MDBCol lg="7">
                <a className="pink-text">
                    <h6 className="font-weight-bold mb-3">

                    </h6>
                </a>
                <h3 className="font-weight-bold mb-3 p-0">
                    <strong align="justify">{props.title}</strong>
                </h3>
                <p align="justify">
                    {`${topChars(props.description)}...`}
                </p>
                <p>
                    <a >
                    </a>
                </p>
                <TransModal title={props.title} description={props.description} />
            </MDBCol>
            <MDBCol lg="5">
                <Carusel imgs={props.images} />
            </MDBCol>
        </MDBRow>
    );
};

export default RightArticle;


// WEBPACK FOOTER //
// ./src/views/GenericPage/Sections/RightArticle.jsx